import React from 'react'

const CookiesButton = ({text}) => {
  return (
   <button className='w-full bg-bbf-white font-roboto text-bbf-black p-3 xs:text-[13px] lg:text-[15px] hover:bg-opacity-75'>{text}</button>
  )
}

export default CookiesButton